import { HttpClient as client } from "@microbeta/common-frontend";

export const httpClient = new client(10000);
